import { useIntl } from 'react-intl';

import { Fields } from '../../../constants';
import { DatabaseTypeField } from '../DatabaseTypeField';
import { PasswordField } from '../PasswordField';
import { TextField } from '../TextField';

export const DatabaseCredentialsFields = () => {
    const { formatMessage } = useIntl();

    return (
        <>
            <TextField name={Fields.DATABASE_NAME} />
            <DatabaseTypeField />
            <TextField name={Fields.SERVER} placeholder={formatMessage({ id: `secret.${Fields.SERVER}.placeholder` })} />
            <TextField name={Fields.PORT} transformValue={val => val.replace(/[^\d]/g, '')} />
            <TextField name={Fields.USERNAME} />
            <PasswordField />
        </>
    );
};
